export const config = {
  CDN_URL: "https://cdn.slotcousins.com/",
  API_URL: "https://api.slotcousins.com/api",
  LOCAL_URL: "http://localhost:3320/api/v1",
};
